import { render, staticRenderFns } from "./Azilect.vue?vue&type=template&id=9d661b6a&scoped=true"
import script from "./Azilect.vue?vue&type=script&lang=js"
export * from "./Azilect.vue?vue&type=script&lang=js"
import style0 from "./Azilect.vue?vue&type=style&index=0&id=9d661b6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d661b6a",
  null
  
)

export default component.exports